import BlockchainIcon from './BlockchainIcon'

export default BlockchainIcon
